export default __webpack_public_path__ + "static/media/box.30c65710.png";